import { Base } from '@studiometa/js-toolkit';

/**
 * MenuItemCollection component
 */
export default class MenuItemCollection extends Base {
  static config = {
    name: 'MenuItemCollection',
    options: {
      image: String,
    },
  };
}
